import { Address } from './types'

type AddressIdParts = Pick<Address, 'zipCode' | 'number' | 'complement'>

export const makeAddressId = (addr: AddressIdParts) =>
  `${addr.zipCode.replace('-', '')}.${addr.number || 0}.${
    addr.complement || ''
  }`
